import React, { useState } from "react";
import Styles from "../../assets/styles/sidebar.module.scss";
import { Divider, Box, Typography, Tooltip, IconButton, Menu, MenuItem } from "@mui/material";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const Sidebar = ({ menu, onNavigate, title, isCollapsed, toggleSidebar }) => {
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);

  const handleSubMenu = (i) => {
    if (isCollapsed) return; // Disable inline submenu in collapsed mode
    setOpenSubMenu((prevState) => (prevState === i ? null : i));
  };

  const handleOpenPopover = (event, item) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(item);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
    setActiveMenu(null);
  };
  return (
    <div className={Styles.SidebarContainer} style={{ width: isCollapsed ? "80px" : "100%", position: "relative" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: isCollapsed ? "center" : "flex-start", padding: "10px" }}>
        {!isCollapsed ? <Typography className={Styles.sidebarHeading} sx={{ fontSize: "18px", textAlign: "left" }}>{title}</Typography> : <Typography sx={{ fontSize: "12px", textAlign: "left" }}>STAFF</Typography>}
      </Box>
      <Divider
        sx={{
          width: "100%",
          alignSelf: "center",
          opacity: 0.4,
          backgroundColor: "white",
        }}
      />
      <Box
        sx={{ paddingLeft: isCollapsed ? "0" : "10px", paddingRight: isCollapsed ? "0" : "10px", alignItems: isCollapsed ? "center" : "flex-start" }}
        mt={2}
        className={Styles.sideBarContent}
      >
        {menu.map((e, i) => {
          const isSubMenuOpen = openSubMenu === i;
          const content = (
            <Box
              className={Styles.SidebarLabelContainer}
              onClick={(event) => {
                if (isCollapsed && e?.subMenu?.length > 0) {
                  handleOpenPopover(event, e);
                } else if (e?.subMenu?.length > 0) {
                  handleSubMenu(i);
                } else {
                  if (e.target === "_blank") {
                    window.open(e.path, "_blank");
                  } else {
                    onNavigate(e);
                  }
                }
              }}
              key={i}
              sx={{
                justifyContent: isCollapsed ? "center" : "flex-start",
                padding: isCollapsed ? "10px 0" : "8px 10px",
                width: "100%", // Force full width for the container
                marginLeft: isCollapsed ? "0" : "0",
                display: "flex", // Ensure flex layout
                alignItems: "center", // Center items vertically
                gap: isCollapsed ? "0" : "20px" // Adjust gap
              }}
            >
              {e.icon}
              {!isCollapsed && (
                <Typography className={Styles.SidebarLabel}>
                  {e.title}
                </Typography>
              )}
            </Box>
          );

          if (menu && e?.subMenu?.length > 0) {
            return (
              <Box
                key={i}
                sx={{ marginBottom: isSubMenuOpen ? "20px" : "0px", width: "100%", display: "flex", flexDirection: "column", alignItems: isCollapsed ? "center" : "stretch" }}
              >
                {isCollapsed ? (
                  <Tooltip title={e.title} placement="right">
                    {content}
                  </Tooltip>
                ) : content}

                {isSubMenuOpen && !isCollapsed &&
                  e.subMenu.map((sub, index) => {
                    return (
                      <Box key={index} className={Styles.SubNavBox}>
                        <Box
                          className={Styles.treeLine}
                          sx={{ height: index === 0 ? "20px" : "36px" }}
                        ></Box>
                        <Typography
                          onClick={() => onNavigate(sub)}
                          className={Styles.SubNavTitle}
                          sx={{ top: index === 0 ? "11px" : "18px" }}
                        >
                          &nbsp;{sub.title}
                        </Typography>
                      </Box>
                    );
                  })}
              </Box>
            );
          } else {
            return (
              <Box key={i} sx={{ width: "100%", display: "flex", justifyContent: isCollapsed ? "center" : "flex-start" }}>
                {isCollapsed ? (
                  <Tooltip title={e.title} placement="right">
                    {content}
                  </Tooltip>
                ) : content}
              </Box>
            );
          }
        })}
      </Box>
      <Box className={Styles.logoutContainer}>
        <Tooltip title={isCollapsed ? "Log out" : ""} placement="right">
          <Box
            className={Styles.SidebarLabelContainer}
            sx={{ margin: isCollapsed ? "0 0 8px 0" : "0 10px 8px 10px", justifyContent: isCollapsed ? "center" : "flex-start" }}
            onClick={() => {
              localStorage.removeItem("token");
              onNavigate("login");
            }}
          >
            <Typography className={Styles.SidebarIcon}>
              <LogoutOutlinedIcon />
            </Typography>
            {!isCollapsed && <Typography className={Styles.SidebarLabel}>Log out</Typography>}
          </Box>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            ml: 1, // Add space between sidebar and menu
            boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
            minWidth: '180px',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            padding: '4px 0'
          }
        }}
      >
        {activeMenu?.subMenu?.map((sub, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              onNavigate(sub);
              handleClosePopover();
            }}
            sx={{
              fontFamily: "'Bahnschrift', sans-serif",
              fontSize: '14px',
              color: '#333',
              padding: '10px 20px',
              '&:hover': {
                backgroundColor: '#f5f5f5',
                color: '#009688'
              }
            }}
          >
            {sub.title}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default React.memo(Sidebar);
